module.exports = __webpack_public_path__ + "img/logo-web.2d465fe5.png";